export const PLACE_SELECTION_HINT =
  "Sélectionnez l'adresse dans la liste proposée pour remplir la rue, le code postal et la ville";

export const ZIP_CODE_PATTERN = /^\d{5}$/;

export const ZIP_CODE_FORMAT_ERROR = 'Cinq chiffres';

export const ADDRESS_TITLE_LABEL = "Titre de l'adresse";

export const ADDRESS_COMMENT_LABEL = 'Commentaire livreur';
